<div
    class="inline-flex h-[32px] items-center justify-center rounded px-4 py-1"
    [class.font-bold]="isBold(castedColumnModel.propertyName)"
    [ngClass]="bgColor">
    {{ descriptionColumn }}
</div>
